<template>
    <div class="share-invite-popup-menu" ref="share">
        <div class="share-invite-popup-menu--wrapper">
            <div class="share-invite-popup-menu--container">
                <header class="share-invite-popup-menu--header">
                    <!-- Import successful. Now, share your invite link. -->
                    <h2 class="share-invite-popup-menu--title" >{{ $store.state.import_count }} creator{{ $store.state.import_count > 1 ? 's have' : ' has' }} been added</h2>
                    <div class="share-invite-popup-menu--skip" @click="close(true)"><svg><use xlink:href="#close--sprite"></use></svg></div>
                </header>
                <div class="text">
                    <slot></slot>
                </div>
                <div class="share-invite-popup-menu--body" @click="copy('link')">
                    <!-- <span class="link"> {{ share_url }}</span> -->
                    <Button type="button" :border_r="6" :style="'border'" size="40" @click.stop="share()">Share invite</Button>
                    <Button type="button" :border_r="6" color="dark-blue" size="40" @click.stop="shareTo('email')">Invite now</Button>
                    <!-- <span class="btn">Copy</span>
                    <span @click.stop="shareTo('email')" class="icon icon-email"><svg><use xlink:href="#email--sprite"></use></svg></span> -->
                </div>

            </div>
            <div class="share-invite-popup-menu--bg" @click="close(false)"></div>
        </div>
    </div>
        
</template>

<script>
import copyToClipboard from 'copy-to-clipboard';
import Button from '@/components/ui/Button.vue';


export default {
    name: 'ShareInvite',
    components:{
        Button
    },

    data() {
        return {
            title: 'Share title',
            image: '',
            description: 'Share description',
            share_url: '',
            hostname: 'https://motom.me',
        }
    },

    methods: {
        share() {
            const obj = {};
            obj.type = 'invite';
            this.EventBus.emit('open-share', obj);
        },

        open() {
            this.share_url = `${this.$store.state.user_data.creator_portal_url}/start-invite?k=${this.$store.state.user_data.merchant_account.unique_key}&s=rs`;
         
            this.$refs.share.classList.add('open');

            setTimeout(() => {
                this.$refs.share.classList.add('open-bg');
            }, 10);

            setTimeout(() => {
                this.$refs.share.classList.add('open-container');
            }, 150);
            
        },

        close(is_click_button_close) {            
            if (this.$refs.share) this.$refs.share.classList.remove('open-container');
            
            setTimeout(() => {
                if (this.$refs.share) this.$refs.share.classList.remove('open-bg');
            }, 200);

            setTimeout(() => {
                if (this.$refs.share) this.$refs.share.classList.remove('open');
                this.$emit('closeCallback');

                if (is_click_button_close) {
                    this.$emit('callback');
                }
            }, 300);
        },
        shareTo(type) {
            let link = this.share_url;
            let share_url = link;

            switch (type) {

                case 'email':
                    const brand_name = this.$store.state.user_data.merchant_account.merchant_display_name;

                    this.title = `Invitation to launch ${brand_name} storefront`;
                    if (this.$ProjectName === 'sephora') {
                        this.description = `
Hi there,
%0A
We’re so excited to begin our collaboration! You will manage your Sephora storefront via our Sephora creator portal. Please create your Sephora creator account using this link: ${encodeURIComponent(this.share_url)}
`;
                    } else {
                        this.description = `
Hi there,
%0A
We're so excited to begin our collaboration! You will manage your ${brand_name} storefront via Anchor by Motom’s creator portal. If you do not already have an Anchor by Motom account, please create one account using this link: ${encodeURIComponent(this.share_url)}
`;
                    }

                    share_url = 'mailto:?subject=' + this.title + '&body='+ this.description;
                    break;
            }

            if (type !== 'share') window.open(share_url, '_blank');

        },

        copy(type) {
            let text = this.$refs.text ? this.$refs.text.innerHTML : '';
            let link = this.share_url;

            
            switch (type) {
                case 'text':
                    copyToClipboard(text, {format:'text/plain'});
                    break;
                case 'link':
                    copyToClipboard(link, {format:'text/plain'});
                    break;
            }

            this.close();
            this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Link copied`);

        },
    },

    mounted() {
        this.hostname = window.location.host;
    },
}
</script>

<style lang="scss">
    .share-invite-popup-menu {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 999999;
        display: none;

        &--wrapper {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            overflow: hidden;
        }

        &--container {
            position: absolute;
            z-index: 9;
            overflow: hidden;
            left: 32px;
            bottom: 48px;
            width: 100%;
            transition: transform .3s ease;
            background: white;
            border-radius:  16px;
            max-width: 548px;
            box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.1);
            transition: transform .3s ease;
            transform: translate3d(0%, calc(100% + 48px), 0);
        }

        &--bg {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
            background: rgba(#000, .6);
            opacity: 0;
            transition: opacity .2s ease;
        }

        &--header {
            padding: 0 8px 0 16px;
            display: flex;
            height: 48px;
            box-sizing: content-box;
            align-items: center;
            border-bottom: 1px solid var(--black-20);
        }

        &--title {
            font: var(--font-demi-20);
            color: var(--black-90);
            flex: 1;
        }

        &--body {
            color: var(--black-90);
            background: white;
            overflow: hidden;
            padding: 16px;
            cursor: pointer;
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap:8px;

            .link {
                display: block;
                font-weight: 500;
                color: var(--black-75);
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                border: 2px solid var(--black-20);
                padding: 0 12px;
                height: 40px;
                line-height: 40px;
                flex: 1;
                border-radius: 8px;
                box-sizing: content-box;
                color: var(--black-90);
            }

            .btn {
                font: var(--font-fg-16);
                padding: 0 16px;
                height: 40px;
                line-height: 38px;
                border: 2px solid var(--black-40);
                border-radius: 22px;
                box-sizing: content-box;
                color: var(--black-50);
                margin-left: 16px;
            }

            .icon {
                height: 24px;
                width: 24px;
                cursor: pointer;
                margin-left: 24px;
                margin-right: 12px;

                svg {
                    height: 100%;
                    width: 100%;
                    display: block;
                    fill: var(--dark-blue);
                }
            }
        }

        .text {
            padding: 24px;
            display: flex;
            align-items:  center;
            color: var(--black-90);

            svg {
                height: 64px;
                width: 64px;
                min-width: 64px;
                display: block;
                margin-right: 24px;
            }

            h3 {
                font: var(--font-fg-16);
                margin-bottom: 8px;
            }
        }

        &--skip {        
            color: white;

            svg {
                cursor: pointer;
                height: 12px;
                width: 12px;
                display: block;
                position: relative;
                right: 10px;
                fill: var(--black-50);
            }

            &:hover svg {
                fill: var(--dark-blue);
            }
        }

        &.open {
            display: block;
        }

        &.open-container &--container {
            transform: translate3d(0%, 0%, 0);
        }

        &.open-bg &--bg {
            opacity: 1;
        }
    }

</style>
